import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M12.06 13.18C14.749 13.18 16.938 10.895 16.938 8.087C16.938 5.282 14.749 3 12.06 3C9.37104 3 7.18604 5.282 7.18604 8.086C7.18604 10.895 9.37204 13.18 12.06 13.18ZM12.06 4.5C13.922 4.5 15.438 6.109 15.438 8.086C15.438 10.067 13.922 11.679 12.06 11.679C10.2 11.679 8.68604 10.067 8.68604 8.086C8.68604 6.109 10.199 4.5 12.06 4.5V4.5Z"
      fill="currentColor"
    />
    <path
      d="M18.92 17.278C18.522 17.392 18.29 17.807 18.403 18.205C18.524 18.628 18.606 19.06 18.65 19.5H5.34999C5.53799 17.611 6.42899 15.892 7.86099 14.698C8.17899 14.432 8.22199 13.96 7.95699 13.641C7.69099 13.324 7.21899 13.279 6.90099 13.545C4.93899 15.18 3.81299 17.624 3.81299 20.249C3.81299 20.663 4.14899 20.999 4.56299 20.999H19.438C19.852 20.999 20.188 20.663 20.188 20.249C20.188 19.414 20.073 18.588 19.847 17.794C19.733 17.396 19.322 17.164 18.92 17.278V17.278Z"
      fill="currentColor"
    />
    <path
      d="M20.5169 10.394C20.1949 10.131 19.7619 10 19.2159 10C18.5539 10 17.9269 10.166 17.3369 10.497L17.7699 11.367C18.2779 11.107 18.7319 10.978 19.1279 10.978C19.3549 10.978 19.5339 11.023 19.6599 11.113C19.7879 11.203 19.8509 11.334 19.8509 11.506C19.8509 11.66 19.8069 11.799 19.7179 11.924C19.6289 12.049 19.4449 12.21 19.1669 12.408C18.8789 12.62 18.6799 12.82 18.5719 13.008C18.4639 13.196 18.4089 13.417 18.4089 13.671V13.965H19.4619V13.726C19.4619 13.567 19.4959 13.439 19.5629 13.342C19.6309 13.243 19.7919 13.099 20.0459 12.912C20.4179 12.647 20.6689 12.409 20.8019 12.197C20.9349 11.985 20.9999 11.734 20.9999 11.443C20.9999 11.005 20.8399 10.656 20.5169 10.394V10.394Z"
      fill="currentColor"
    />
    <path
      d="M18.982 16C19.198 16 19.369 15.939 19.49 15.819C19.611 15.699 19.673 15.533 19.673 15.324C19.673 15.107 19.612 14.94 19.492 14.824C19.372 14.708 19.201 14.65 18.981 14.65C18.752 14.65 18.579 14.707 18.46 14.821C18.341 14.935 18.281 15.103 18.281 15.325C18.281 15.54 18.342 15.707 18.464 15.824C18.586 15.941 18.759 16 18.982 16V16Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'PersonQuestion');

export default Icon;
